export const xxSmallDevices = 'only screen and (max-width: 359px)'
export const xxSmallDevicesLandscape = 'only screen and (max-width: 767px) and (orientation: landscape)'
export const extraSmallDevices = 'only screen and (min-width: 360px) and (max-width: 479px)'
export const extraSmallDevicesLandscape = 'only screen and (min-width: 480px) and (max-width: 767px) and (orientation: landscape)'
export const mediumDevices = 'only screen and (min-width: 480px) and (max-width: 899px)'
export const mediumDevicesLandscape = 'only screen and (min-width: 768px) and (max-width: 1023px)'
export const largeDevices = 'only screen and (min-width: 900px) and (max-width: 1199px)'
export const extraLargeDevices = 'only screen and (min-width: 1200px) and (max-width: 1439px)'
export const xxLargeDevices = 'only screen and (min-width: 1440px)'
